import clsx from 'clsx';
import type { FC } from 'react';

interface MessageItemCellProps {
	topic?: string;
	author?: string;
	isUnread: boolean;
}

export const MessageItemCell: FC<MessageItemCellProps> = ({
	topic,
	author,
	isUnread,
}) => (
	<div className="min-w-0">
		<div
			className={clsx(
				'text-neutral-950  overflow-hidden text-ellipsis  [display:-webkit-box]  [-webkit-line-clamp:1]  [-webkit-box-orient:vertical]',
				isUnread && 'font-bold',
			)}
		>
			{topic}
		</div>
		<div>{author}</div>
	</div>
);
